import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import type { ReactNode } from 'react';
import { memo, useEffect, useMemo, useRef } from 'react';

import Buckets from '../components/Buckets';
import Hero from '../components/Hero';
import Message from '../components/Message';
import { useContent } from '../hooks/useContent';
import { useUefatvOptions } from '../store';

import { useUser } from '@shared/hooks/useUser';

const Main = ({ placeholder }: { placeholder?: ReactNode }) => {
  const { options } = useUefatvOptions();

  const { logged } = useUser();
  const { data, isLoading, loadMoreContent } = useContent(options.section, logged, options.bpp, options.rpp);
  const spyRef = useRef(undefined);
  const scrolled = useViewportSpy(spyRef);

  useEffect(() => {
    scrolled && loadMoreContent();
  }, [scrolled, loadMoreContent]);
  const heroes = useMemo(() => data?.[0]?.heroes, [data]);
  const buckets = useMemo(() => data?.flatMap((d) => d.buckets), [data]);

  return (
    <>
      {isLoading && placeholder}
      <Message />
      <Hero heroes={heroes} />
      <div className='pk-container'>
        <div className='pk-col pk-col--span-12 pk-col--mobile-full-width'>
          {buckets && <Buckets key={`buckets-${logged}`} buckets={buckets} />}
        </div>
      </div>
      <div ref={spyRef} />
    </>
  );
};
export default memo(Main);
